export function getTranslationKeyFromDatabaseProperty(property: string): string {
  return property.replace(/_/g, '-').toLowerCase();
}
